/**
 * @file UI Store (Zustand) — локальный UI-стейт
 * @see docs/tz/00-architecture.md §7.2 State Management
 */
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface UIState {
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;

  presentationMode: boolean;
  togglePresentation: () => void;

  portfolioFilters: {
    status?: string;
    type?: string;
    region?: string;
    search?: string;
  };
  setPortfolioFilters: (filters: Partial<UIState["portfolioFilters"]>) => void;
  clearPortfolioFilters: () => void;

  activeModal: string | null;
  openModal: (id: string) => void;
  closeModal: () => void;

  selectedProjectId: string | null;
  setSelectedProjectId: (id: string | null) => void;

  accentColor: string;
  setAccentColor: (color: string) => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      toggleSidebar: () =>
        set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),

      presentationMode: false,
      togglePresentation: () =>
        set((s) => ({ presentationMode: !s.presentationMode })),

      portfolioFilters: {},
      setPortfolioFilters: (filters) =>
        set((s) => ({
          portfolioFilters: { ...s.portfolioFilters, ...filters },
        })),
      clearPortfolioFilters: () => set({ portfolioFilters: {} }),

      activeModal: null,
      openModal: (id) => set({ activeModal: id }),
      closeModal: () => set({ activeModal: null }),

      selectedProjectId: null,
      setSelectedProjectId: (id) => set({ selectedProjectId: id }),

      accentColor: "blue",
      setAccentColor: (color) => set({ accentColor: color }),
    }),
    {
      name: "multiservice-ui",
      partialize: (s) => ({
        sidebarCollapsed: s.sidebarCollapsed,
        portfolioFilters: s.portfolioFilters,
        selectedProjectId: s.selectedProjectId,
        accentColor: s.accentColor,
      }),
    },
  ),
);
